export default __webpack_public_path__ + "static/media/iam_organism.55ef9d09.svg";